import styles from './index.module.scss'

export function ImageSkeleton(props: any) {
  // eslint-disable-next-line react/destructuring-assignment
  return <div className={styles.image}>{props.children}</div>
}
